<template>
  <div>
    <!-- 常用设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.general.001') }}</span>
      </el-col>
      <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.general.002') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('messageAdd.general.003') }}</span>
        <el-select size="medium" v-model="c.bt">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('messageAdd.general.004') }}</span>
        <el-select size="medium" v-model="c.gp">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('messageAdd.general.005') }}</span>
        <el-select size="medium" v-model="c.nf">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('messageAdd.general.006') }}</span>
        <el-select size="medium" v-model="c.cm">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.general.007') }}</span>
        <!-- <span class="tips-text2">*{{ $t('messageAdd.note.004') }}</span> -->
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('messageAdd.general.008') }}</span>
        <el-select size="medium" v-model="c.sl">
          <el-option :label="$t('messageAdd.general.010')" :value="0"></el-option>
          <el-option :label="$t('messageAdd.general.011')" :value="1"></el-option>
        </el-select>
      </el-col>
      <!-- <el-col :span="10" class="setting-box">
        <span class="setTitle">{{$t('messageAdd.general.009')}}</span>
        <el-select size="medium"  v-model="c.ns">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="1"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="0"></el-option>
        </el-select>
      </el-col> -->
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("messageAdd.general.012") }}:</span>
        <el-select size="medium" v-model="c.nb">
          <el-option :label="$t('common.hide')" :value="0"></el-option>
          <el-option :label="$t('common.show')" :value="1"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("messageAdd.general.013") }}:</span>
        <el-select size="medium" v-model="c.sm">
          <el-option :label="$t('message.systemMsg.switchSelect.open')" :value="true"></el-option>
          <el-option :label="$t('message.systemMsg.switchSelect.close')" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="deactText">*{{ $t('messageAdd.note.004') }}</span>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "DisplaySettings",
  props: {
    GeneralSet: {
      type: Object
    }
  },
  data() {
    return {

    };
  },
  computed: {
    c() {
      return this.GeneralSet
    }
  },
  watch: {
    // 监听 c 的变化，并通知父组件
    c: {
      handler(newVal) {
        this.$emit('update:GeneralSet', newVal);
        this.$emit('update:config-GeneralSet', newVal);
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {},
}
</script>